import(/* webpackMode: "eager" */ "/app/src/app/(auth)/registerNew/page.tsx");
